interface BaseAction {
    type: string;
}

export interface Store<S extends Record<string, unknown>, A extends BaseAction> {
    dispatch(action: A): void;
    subscribe(listener: () => void): () => void;
    getState(): S;
}

export function createStore<S extends Record<string, unknown>, A extends BaseAction>(
    r: (state: S, action: A) => S,
    initialState: S,
): Store<S, A> {
    let state = initialState;
    const subscribers: Array<() => void> = [];

    return {
        dispatch(action: A) {
            state = r(state, action);
            subscribers.forEach(fn => fn());
        },
        subscribe(listener: () => void) {
            subscribers.push(listener);

            let isSubscribed = true;

            return function unsubscribe() {
                if (!isSubscribed) {
                    return;
                }

                const index = subscribers.indexOf(listener);
                subscribers.splice(index, 1);
                isSubscribed = false;
            };
        },
        getState() {
            return state;
        },
    };
}
